import React, { useEffect, useState } from 'react';
import axios from 'axios';

export default function AdminPortalSelector({ currentId = '', getAuthHeaders }) {
  const [accounts, setAccounts] = useState([]);
  const [selected, setSelected] = useState(currentId);
  const [status, setStatus] = useState('loading');
  const [attempt, setAttempt] = useState(0);
  useEffect(() => {
    const controller = new AbortController();
    setStatus('loading');
    axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/syndications/portal/accounts`, {
      headers: { ...getAuthHeaders(), 'X-Tenant': 'live' }, signal: controller.signal,
    }).then(response => { if (!controller.signal.aborted) { setAccounts(response.data); setStatus('ready'); } })
      .catch(() => { if (!controller.signal.aborted) setStatus('error'); });
    return () => controller.abort();
  }, [getAuthHeaders, attempt]);
  return <section className="ip-admin-switch" aria-label="Administrator portal viewer">
    <div><strong>View as syndicator</strong><p>Choose whose investor portal you want to view.</p></div>
    {status === 'error' ? <div role="alert">Could not load syndicators. <button onClick={() => setAttempt(attempt + 1)}>Try again</button></div>
      : <form action={selected ? `/portal/${encodeURIComponent(selected)}` : '/portal'}>
        <label htmlFor="portal-account">Syndicator</label>
        <select id="portal-account" value={selected} onChange={e => setSelected(e.target.value)} disabled={status === 'loading'}>
          <option value="">{status === 'loading' ? 'Loading syndicators…' : 'Select a syndicator'}</option>
          {accounts.map(account => <option key={account.id} value={account.id}>{account.name}</option>)}
        </select>
        <button type="submit" disabled={!selected || status !== 'ready'}>View portal</button>
        {status === 'ready' && !accounts.length && <span>No syndicator accounts found.</span>}
      </form>}
    <a href="/syndication-dashboard">Back to CRM</a>
  </section>;
}
